import { render, staticRenderFns } from "./pczx_room_manage.vue?vue&type=template&id=c56b1d5a&"
import script from "./pczx_room_manage.vue?vue&type=script&lang=js&"
export * from "./pczx_room_manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports